// We are using this implementation instead the gatsby#withPrefix
// because the project has support to Chromatic and Storybook.
// Otherwise, these tools would need to have the same webpack
// customizations that gatsby has today
//
// We are doing it today just because we want to drop gatsby and today

import {
  isDevExtensionsMode,
  isNodeEnvProduction,
  isRunningInsideInstoreCore,
} from './EnvUtils'

// the withPrefix is one of the few features that we use from it
export const withPrefix = (path: string) => {
  if (
    isNodeEnvProduction() &&
    isRunningInsideInstoreCore() &&
    !isDevExtensionsMode()
  ) {
    return `/assisted-sales/${path.replace(/^\//, '')}`
  }

  return path
}
